{
  "$id": "wealthlane://forms/customer-success-automation/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [
    {
      "watch": "sourceCompanyId",
      "clear": ["sourceRoleId"]
    },
    {
      "watch": "destinationCompanyId",
      "clear": ["destinationRoleId"]
    }
  ],
  "observers": [],
  "rules": []
}
